import React, { Component } from 'react'
import { Button, Tooltip, Icon } from 'antd'
import { CSVLink } from 'react-csv'
import { mapToKeys } from '../../modules/Utils'

class csvExportButton extends Component {
  render() {
    const { data, columns = [], fileName, disabled, title = '' } = this.props
    const csvSelection = data.map(i =>
      mapToKeys(
        i,
        columns.map(c => c.accessor),
        columns.map(c => c.Header),
      ),
    )

    const fullFileName = `${fileName}-${new Date().getTime()}.csv`
    return (
      <Tooltip title="Export CSV">
        <Button size="small" disabled={disabled} style={{ marginRight: 10 }} type={'dashed'}>
          <CSVLink filename={fullFileName} data={csvSelection}>
            <Icon type="download" />
            {title && <span style={{ marginLeft: 5 }}>{title}</span>}
          </CSVLink>
        </Button>
      </Tooltip>
    )
  }
}

csvExportButton.defaultProps = { csvSelection: [], disabled: false }

export default csvExportButton
